export default async function getBuildInfo() {
    const isRunningLocally = process.env.NODE_ENV === 'development';

    if (!isRunningLocally) {
        const res = await fetch('/static/build.json', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });

        try {
            return await res.json();
        } catch (err) {
            console.error('build.json file was not retrieved');
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/getBuildInfo.js